import { useTranslation } from 'react-i18next';
import { PaymentMethod } from './usePaymentMethods';

/**
 * Mollie names the methods itself, but some of those names read poorly in a booking
 * flow — "Card" for creditcard being the obvious one. Where we have a better name (or
 * a line of reassurance to put under it), ours wins; otherwise Mollie's stands.
 */
export default function usePaymentMethodLabel() {
    const { t } = useTranslation('general');

    return {
        label: (method: PaymentMethod) =>
            t(`mollie.paymentMethods.names.${method.id}`, { defaultValue: method.description }),
        hint: (method: PaymentMethod) => t(`mollie.paymentMethods.hints.${method.id}`, { defaultValue: '' })
    };
}
